import React from 'react';
import { useAuth } from '../context/AuthContext';
import { Button } from './ui/button';
import { Clock, LogOut } from 'lucide-react';

export default function SessionTimeoutWarning() {
  const { showTimeoutWarning, extendSession, logout } = useAuth();

  if (!showTimeoutWarning) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50">
      <div className="bg-background rounded-lg shadow-xl p-6 max-w-md mx-4 animate-in fade-in zoom-in duration-200">
        <div className="flex items-center gap-3 mb-4">
          <div className="p-3 bg-amber-100 rounded-full">
            <Clock className="text-amber-600" size={24} />
          </div>
          <div>
            <h3 className="font-heading text-lg font-semibold">Session Expiring</h3>
            <p className="text-sm text-muted-foreground">Your session will expire in 2 minutes</p>
          </div>
        </div>
        
        <p className="text-muted-foreground mb-6">
          For your security, you will be automatically logged out due to inactivity. 
          Would you like to continue your session?
        </p>
        
        <div className="flex gap-3">
          <Button
            onClick={extendSession}
            className="flex-1"
          >
            Continue Session
          </Button>
          <Button
            variant="outline"
            onClick={logout}
            className="flex items-center gap-2"
          >
            <LogOut size={16} />
            Logout
          </Button>
        </div>
      </div>
    </div>
  );
}
